import { render } from "./DocumentClassAttributes.vue?vue&type=template&id=78ed1e74&scoped=true&ts=true"
import script from "./DocumentClassAttributes.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributes.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributes.vue?vue&type=style&index=0&id=78ed1e74&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ed1e74"]])

export default __exports__